<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">   
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item style="width:19%">
          	  <el-date-picker v-model="query.date" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :unlink-panels="false" style="width:100%"></el-date-picker>
          </el-form-item>
          <el-form-item style="width:13%">
          	  <el-select v-model="query.pid" clearable remote  filterable placeholder="请选择广告位">
	          	  <el-option v-for="(item,index) in plists" :label="item.name" :value="item.id" :key="index"></el-option>
	          </el-select>          
          </el-form-item>
          <el-form-item style="width:13%">
          	  <el-select v-model="query.type" clearable remote  filterable placeholder="请选择跳转类型">
	          	  <el-option v-for="(item,index) in typelists" :label="item.name" :value="item.id" :key="index"></el-option>
	          </el-select>          
          </el-form-item>
          <el-form-item style="width:13%">
              <el-input placeholder="请输入关键字" v-model="query.key" clearable @keyup.enter.native="getList" @change="changesearch"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" circle @click="getadlists"></el-button>
              <el-button type="danger" icon="el-icon-plus" circle @click="add" v-if="actionauth.mall_ad_add=='true'"></el-button>
			  <el-button type="warning" icon="el-icon-search" circle @click="getpositioninfos"></el-button>
			  <el-button type="warning" icon="el-icon-setting" @click="setaplike">设置广告位搜索喜好</el-button>
          </el-form-item>
		  <el-form-item style="width:100%">
		  	  <div style="float:left;width:100%">
				  <el-button size="mini" round v-for="(item,index) in apsearchlists" :key="index" @click="searchap(item.id)" style="margin-bottom:10px">{{item.name}}</el-button>	
			  </div>
		  </el-form-item>   
      </el-form>
      
      <!-------------  广告管理信息列表  -------------->
      <div class="backborder2" style="margin-top:10px">
	      <el-table :data="lists" v-loading="listsLoading">
	      	  <el-table-column label="图片">
	      	  	  <template slot-scope="scope">
	      	  	  	  <div style="float:left;width:160px;height:80px;border:1px solid #ddd;border-radius:5px;overflow:hidden;padding:5px">
						  <img :id="'imginfo'+scope.row.id" :src="scope.row.showthumb" class="showadimg"
						  :style="'width:'+scope.row.width+';height:'+scope.row.height+';margin-left:'+scope.row.left+';margin-top:'+scope.row.top+''"/>
					  </div>
	      	  	  	  <div style="float:left;margin-left:2%;width:70%;margin-top:5px">
						  <i style="float:left;font-style:normal;margin-right:3%;margin-top:1px;font-size:12px;line-height:12px;padding:3px 5px;border-radius:5px;background:#409EFF;color:#fff">广告名称</i>
						  <span style="float:left;color:#666666">{{scope.row.name}}</span>
					  </div>
					  <div style="float:left;margin-left:2%;width:70%;margin-top:5px">
						  <i style="float:left;font-style:normal;margin-right:3%;margin-top:1px;font-size:12px;line-height:12px;padding:3px 5px;border-radius:5px;background:#F56C6C;color:#fff">广告位置</i>
						  <span style="float:left;color:#666666">{{scope.row.pname}}</span>
					  </div>
					  <div style="float:left;margin-left:2%;width:70%;margin-top:5px">
						  <i style="float:left;font-style:normal;margin-right:3%;margin-top:1px;font-size:12px;line-height:12px;padding:3px 5px;border-radius:5px;background:#E6A23C;color:#fff">跳转类型</i>
						  <span style="float:left;color:#666666">{{scope.row.typename}}</span>
					  </div>
				  </template>
	      	  </el-table-column>
	          <el-table-column label="广告时间" width="320" align="center">
			  	  <template slot-scope="scope">
					<span>{{scope.row.time}}</span>
					<i style="color:#909399;font-style:normal;font-size:12px" v-if="scope.row.status=='未开始' || scope.row.status=='已结束'">（{{scope.row.status}}）</i>
					<i style="color:#67C23A;font-style:normal;font-size:12px" v-if="scope.row.status=='进行中'">（{{scope.row.status}}）</i>
				  </template>
			  </el-table-column>
			  <!--
	          <el-table-column label="状态" width="90" align="center">
	          	  <template slot-scope="scope">
	      	  	  	  <el-tag type="info" v-if="scope.row.status=='未开始'">未开始</el-tag>
	      	  	  	  <el-tag type="success" v-if="scope.row.status=='进行中'">进行中</el-tag>
	      	  	  	  <el-tag type="info" v-if="scope.row.status=='已结束'">已结束</el-tag>
	      	  	  </template>
	          </el-table-column>   
			  -->       
	          <el-table-column label="操作" align="center" width="150">
		          <template slot-scope="scope">
		            <el-button type="primary" size="small" icon="el-icon-edit" circle @click="editCurrent(scope.row)" v-if="actionauth.mall_ad_edit=='true'"></el-button>
		            <el-button type="danger" size="small" icon="el-icon-delete" circle @click="delCurrent(scope.row)" v-if="actionauth.mall_ad_del=='true'"></el-button>
		          </template>
	          </el-table-column>
	      </el-table>
	      <div class="block">
	          <!--分页begin-->
	          <el-pagination
	              @size-change="pageSizeChange"
	              @current-change="pageCurrentChange"
	              :current-page="query.p"
	              :page-sizes="[10, 20, 50]"
	              :page-size="query.rollpage"
	              layout="total, sizes, prev, pager, next, jumper"
	              :total="total_rows">
	          </el-pagination>
	          <!--分页end-->
	      </div>
      </div>
      
      <!-----------  发布广告  --------------->
      <el-dialog title="发布广告" :visible.sync="adDialog" width="45%" top="5vh">
      	  <el-form ref="create" :model="create" label-width="100px" size="medium">
              <el-col :span="23">
	              <el-form-item label="广告名称">
	                  <el-input v-model="create.name" placeholder="请输入广告名称" style="width:90%"></el-input>
	              </el-form-item>
              </el-col>
              <el-col :span="23">
	              <el-form-item label="广告位置">
	                  <el-select v-model="create.pid" clearable filterable placeholder="请选择广告位置" style="width:90%">
		              	  <el-option v-for="(item,index) in plists" :label="item.name" :value="item.id" :key="index"></el-option>
		              </el-select>
	              </el-form-item>
              </el-col>
              <el-col :span="23">
	              <el-form-item label="广告时间">
	              	  <el-date-picker v-model="create.date" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" style="width:90%"></el-date-picker> 
	              </el-form-item>
              </el-col>
              <el-col :span="23">
	              <el-form-item label="跳转类型">
	                  <el-select v-model="create.type" clearable filterable placeholder="请选择跳转类型" style="width:90%">
		              	  <el-option v-for="(item,index) in typelists" :label="item.name" :value="item.id" :key="index"></el-option>
		              </el-select>
	              </el-form-item>
              </el-col>
              <el-col :span="23" v-if="create.type=='2'">
	              <el-form-item label="跳转链接">
	                  <el-input v-model="create.url" placeholder="请输入跳转链接" style="width:90%"></el-input>
	              </el-form-item>
              </el-col>
              <el-col :span="23" v-if="create.type=='3'">
	              <el-form-item label="跳转条件">
	                  <el-select v-model="create.brandid" clearable filterable placeholder="请选择品牌" style="width:30%">
		              	  <el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.id" :key="index"></el-option>
		              </el-select>
		              <el-cascader :options="categorylist" v-model="create.catid" clearable placeholder="请选择分类" change-on-select style="width:30%"></el-cascader>
	              	  <el-select v-model="create.pettype" clearable filterable placeholder="请选择品类" style="width:30%">
		              	  <el-option v-for="(item,index) in pettypelists" :label="item.name" :value="item.id" :key="index"></el-option>
		              </el-select>
	              </el-form-item>
              </el-col>
              <el-col :span="23" v-if="create.type=='4'">
	              <el-form-item label="跳转商品">
	                  <el-button type="primary" size="small" icon="el-icon-search" @click="addgoods('create')">选择商品</el-button>
	                  <el-col :span="23">
	                      <span style="color:#F56C6C" v-for="(item,index) in create.goods">跳转至商品：{{item.name}}</span>
	                  </el-col>
	              </el-form-item>
              </el-col>
              <el-col :span="23">
              	  <el-form-item label="上传图片">
              	  	  <el-tag type="danger">温馨提示：建议上传188px * 64px的图片，图片的大小不超过200k</el-tag>
                  	  <input @change="filecreateminiChange($event,'create')" type="file" id="upload_file">
              	  </el-form-item>
              </el-col>
              <el-col :span="23">
              	  <el-form-item>
              	  	  <img :src="create.showthumb" style="width:90%" v-if="create.thumb!='' && create.thumb!=null">
              	  	  <img src="../../assets/default_img.png" style="width:70%" v-if="create.thumb=='' || create.thumb==null">
              	  </el-form-item>
              </el-col>
          </el-form>
      	  <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="adDialog = false">取 消</el-button>
            <el-button size="medium" type="primary" :loading="createadLoading" @click="createadSave">保 存</el-button>
          </div>
      </el-dialog>
      
      
      <!-----------  编辑广告  --------------->
      <el-dialog title="编辑广告" :visible.sync="updateDialog" width="45%" top="5vh">
      	  <el-form ref="update" :model="update" label-width="100px" size="medium">
              <el-col :span="23">
	              <el-form-item label="广告名称">
	                  <el-input v-model="update.name" placeholder="请输入广告名称" style="width:90%"></el-input>
	              </el-form-item>
              </el-col>
              <el-col :span="23">
	              <el-form-item label="广告位置">
	                  <el-select v-model="update.pid" clearable filterable placeholder="请选择广告位置" style="width:90%">
		              	  <el-option v-for="(item,index) in plists" :label="item.name" :value="item.id" :key="index"></el-option>
		              </el-select>
	              </el-form-item>
              </el-col>
              <el-col :span="23">
	              <el-form-item label="广告时间">
	              	  <el-date-picker v-model="update.date" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" style="width:90%"></el-date-picker> 
	              </el-form-item>
              </el-col>
              <el-col :span="23">
	              <el-form-item label="跳转类型">
	                  <el-select v-model="update.type" clearable filterable placeholder="请选择跳转类型" style="width:90%">
		              	  <el-option v-for="(item,index) in typelists" :label="item.name" :value="item.id" :key="index"></el-option>
		              </el-select>
	              </el-form-item>
              </el-col>
              <el-col :span="23" v-if="update.type=='2'">
	              <el-form-item label="跳转链接">
	                  <el-input v-model="update.url" placeholder="请输入跳转链接" style="width:90%"></el-input>
	              </el-form-item>
              </el-col>
              <el-col :span="23" v-if="update.type=='3'">
	              <el-form-item label="跳转条件">
	                  <el-select v-model="update.brandid" clearable filterable placeholder="请选择品牌" style="width:30%">
		              	  <el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.id" :key="index"></el-option>
		              </el-select>
		              <el-cascader :options="categorylist" v-model="update.catid" clearable placeholder="请选择分类" change-on-select style="width:30%"></el-cascader>
	              	  <el-select v-model="update.pettype" clearable filterable placeholder="请选择品类" style="width:30%">
		              	  <el-option v-for="(item,index) in pettypelists" :label="item.name" :value="item.id" :key="index"></el-option>
		              </el-select>
	              </el-form-item>
              </el-col>
              <el-col :span="23" v-if="update.type=='4'">
	              <el-form-item label="跳转商品">
	                  <el-button type="primary" size="small" icon="el-icon-search" @click="addgoods('update')">选择商品</el-button>
	                  <el-col :span="23">
	                      <span style="color:#F56C6C" v-for="(item,index) in update.goods">跳转至商品：{{item.name}}</span>
	                  </el-col>
	              </el-form-item>
              </el-col>
              <el-col :span="23">
              	  <el-form-item label="上传图片">
              	  	  <el-tag type="danger">温馨提示：建议上传188px * 64px的图片，图片的大小不超过200k</el-tag>
                  	  <input @change="filecreateminiChange($event,'update')" type="file" id="upload_file">
              	  </el-form-item>
              </el-col>
              <el-col :span="23">
              	  <el-form-item>
              	  	  <img :src="update.showthumb" style="width:90%" v-if="update.thumb!='' && update.thumb!=null">
              	  	  <img src="../../assets/default_img.png" style="width:70%" v-if="update.thumb=='' || update.thumb==null">
              	  </el-form-item>
              </el-col>
          </el-form>
      	  <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="updateDialog = false">取 消</el-button>
            <el-button size="medium" type="primary" :loading="updateadLoading" @click="updateadSave">保 存</el-button>
          </div>
      </el-dialog>
      
      
      <!-----------  选择商品信息  ------------>
      <el-dialog title="选择商品信息" :visible.sync="goodsDialog" width="55%" top="5vh">
      	  <el-form :inline="true" class="demo-form-inline">
      	  	  <el-form-item style="width:20%">
	              <el-select v-model="goodsquery.brandid" placeholder="请选择品牌" @change="goodsisnewselect=true" filterable clearable>
	              	  <el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.id" :key="index"></el-option>
	              </el-select>
	          </el-form-item>
      	  	  <el-form-item style="width:20%">
      	  	  	  <el-cascader :options="categorylist" v-model="goodsquery.catid" clearable size="10" placeholder="请选择分类" change-on-select @change="goodsisnewselect=true"></el-cascader>
	          </el-form-item>
	          <el-form-item style="width:25%">
	              <el-input placeholder="请输入关键字" size="35" v-model="goodsquery.key" @keyup.enter.native="getgoodslists"  @change="isnewselect=true"  clearable></el-input>
	          </el-form-item>
	          <el-form-item>
	              <el-button type="primary" icon="el-icon-search" @click="getgoodslists">查询</el-button>
	          </el-form-item>
      	  </el-form>
      	  <el-table :data="goodlists" v-loading="goodsLoading">    	  
      	  	  <el-table-column prop="name" label="商品名称"></el-table-column>         
	          <el-table-column label="操作" align="center" width="90">
		          <template slot-scope="scope">
		              <el-button type="success" size="mini" icon="el-icon-check" circle @click="ensureCurrent(scope.row)"></el-button>
		          </template>
	          </el-table-column>
      	  </el-table>
	      <div class="block">
	          <!--分页begin-->
	          <el-pagination
	              @size-change="goodspageSizeChange"
	              @current-change="goodspageCurrentChange"
	              :current-page="goodslits_total_rows.p"
	              :page-sizes="[10, 20, 50]"
	              :page-size="goodslits_total_rows.rollpage"
	              layout="total, sizes, prev, pager, next, jumper"
	              :total="goodslits_total_rows">
	          </el-pagination>
	          <!--分页end-->
	      </div>
      </el-dialog>

	  <!-- 获取广告位信息 -->
	  <el-dialog title="设置个人广告位搜索信息喜好" :visible.sync="adpDialog" width="45%" top="5vh">
		  <div class="express-warning">注：该项设置为个人快速搜索广告位设置，数据不保存在服务器，保存在浏览器</div>
		  <div style="float:left;width:100%;margin-top:10px;margin-bottom:20px">
		  	  <div style="float:left;margin:0 10px 10px 0" v-for="(item,index) in plists">
				  <el-button style="font-size:12px;padding:5px 10px" :type="item.isselect==0 ? 'info' : 'success'" size="mini" round @click="changelike(item,index)">{{item.name}}</el-button>
			  </div>
		  </div>
		  <div slot="footer" class="dialog-footer">
              <el-button size="medium" @click="adpDialog = false">取 消</el-button>
          </div>
	  </el-dialog>

	  <!-- 获取广告位信息 -->
	  <el-dialog title="广告位信息设置引导" :visible.sync="adplistsDialog" width="50%" top="5vh">
	  	  <div style="display:none"><input type="file" id="shareimg" @change="getaddimg($event)"></div>
	  	  <div class="ad-position-infos">
			  <ul>
			  	<li v-for="(item,index) in plists" :key="index">
				  <a @click="saveapthumbs(item.id,index)">
				  	<img src="../../assets/apdefault.jpg" v-if="item.thumb=='' || item.thumb==null"/>
					<img :src="GLOBAL.staticUrl+item.thumb" v-if="item.thumb!='' && item.thumb!=null"/>
				  </a>
				  <span class="name">{{item.id}}-{{item.name}}</span>
				  <div class="size">
				  	  <el-input placeholder="宽度" v-model="item.width" @blur="changewah(item)" size="small" style="float:left;width:48%" clearable><template slot="append">px</template></el-input><i>*</i> 
				  	  <el-input placeholder="高度" v-model="item.height" @blur="changewah(item)" size="small" style="float:left;width:45%"  clearable><template slot="append">px</template></el-input>
				  </div>
				</li>
			  </ul>
		  </div>
		  <div slot="footer" class="dialog-footer">
              <el-button size="medium" @click="adplistsDialog = false">取 消</el-button>
          </div>
	  </el-dialog>


  </div>
  </transition>  
</template>

<script>

export default {
 
  data () {
    return {
        url:this.GLOBAL.domain+"Ad/index",
        transitionshow:true,
        actionauth:'', //功能权限
        addtype:'',
        brandlists:[],
        categorylist:[],
        plists:[],
        lists:[],
        total_rows: 0,
        listsLoading:false,
		apsearchlists:this.$cookies.get('aplists'),
        query: {
        	act:'lists',
        	token:this.$cookies.get('token'),
      	    pid:'',
      	    date:[],
      	    brandid:'',
      	    catid:'',
      	    pettype:'',
      	    type:'',
      	    key:'',
      	    rollpage: 10, // 页大小
        	p: 1
        },
        
        adDialog:false,
        createadLoading:false,
        create: {
        	act:'addinfos',
        	token:this.$cookies.get('token'),
        	name:'',
        	pid:'',
        	brandid:'',
        	catid:[],
        	date:[],
        	type:'1',
        	pettype:'',
        	url:'',
        	thumb:'',
        	showthumb:'',
        	goods:[]
        },
        typelists:[
        	{id:'1',name:'不做跳转'},
        	{id:'2',name:'跳转链接'},
        	{id:'3',name:'跳转条件'},
        	{id:'4',name:'跳转商品'},
			{id:'7',name:'跳转至新人活动商品列表'},
			{id:'8',name:'跳转至新品专区列表'},
			{id:'9',name:'跳转至特卖活动专区列表'},
			{id:'10',name:'跳转至秒杀活动专区列表'},
			{id:'11',name:'跳转至品牌促销活动'},
			{id:'12',name:'跳转至换购活动专区'},
			{id:'13',name:'跳转至领取优惠券'},	
			{id:'15',name:'跳转至团购（集采）专区'},
			{id:'16',name:'跳转至一件代发'},
			{id:'17',name:'跳转至极速达'},
			{id:'18',name:'跳转至邀请有礼'},
        ],
        pettypelists:[
        	{id:'1',name:'狗狗'},
        	{id:'2',name:'猫猫'},
        	{id:'4',name:'猫狗通用'},
        	{id:'3',name:'小宠'},
        	{id:'9',name:'其它'},
        ],
        
        goodsDialog:false,
        goodsLoading:false,
        goodsisnewselect:false,
        goodlists:[],
        goodslits_total_rows:0,
        pclickstatus:[],
        multipleSelection:[],
        goodsquery: {
        	act:'getgoodslists',
        	token:this.$cookies.get('token'),
        	catid:'',
        	brandid:'',
        	key:'',
        	p:1,
        	rollpage:10
        },
        
        updateDialog:false,
        updateadLoading:false,
        update: {
        	act:'edit',
        	token:this.$cookies.get('token'),
        	id:'',
        	name:'',
        	pid:'',
        	brandid:'',
        	catid:[],
        	date:[],
        	type:'1',
        	pettype:'',
        	url:'',
        	thumb:'',
        	showthumb:'',
        	goods:[]
        },
        
		adpDialog:false,
		adploading:false,
		adplistsDialog:false,
		apthumbquery: {
			act:'saveapthumbs',
			token:this.$cookies.get('token'),
			id:'',
			thumb:'',
			index:'',
		},
    }
  },
    
  mounted(){  
	this.apsearchlists=JSON.parse(this.apsearchlists);
    this.getactionauth();
    this.getposition(); //获取广告位信息
    this.getadlists(); //获取广告信息
    this.getBrand(); //获取品牌信息
    this.getCategoryList(); //获取商品分类信息
    this.agentinternals(); //获取新国货活动的信息（新国货活动结束后删除，2019年1月2日删除）
  },
  
  methods:{
    /** 重置表单 **/
    reset() {
        this.$refs.create.resetFields();
    },
    
    //获取功能权限
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    /** 获取品牌 **/
    getBrand(){
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.query({act:'getsyslists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.brandlists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 获取产品分类 **/
    getCategoryList() {
    	var resource = this.$resource(this.GLOBAL.domain+"Product/index");
        resource.query({ act:'getmallcatelist',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.categorylist = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 获取广告位信息 **/
    getposition() {
    	var resource = this.$resource(this.url);
        resource.query({act:'plists',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.plists = JSON.parse(Base64.decode(res.data.Data));
				var apids=[];
				if(this.apsearchlists) this.apsearchlists.forEach(function(item,i) {apids.push(item.id);});
				this.plists.forEach(function(item,i) {
					apids.indexOf(item.id)==-1 ? item.isselect=0 : item.isselect=1;
				});
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },


	/** 广告位快速搜索数据 **/
	searchap(id) {
		this.query.pid=id;
		this.query.date=[];
		this.query.brandid='';
		this.query.pettype='';
		this.query.type='';
		this.query.key='';
		this.query.p=1;
		this.query.rollpage=10;
		this.getadlists();
	},
    
    /** 获取广告信息 **/
    getadlists() {
    	this.listsLoading=true;
    	var resource = this.$resource(this.url);
        resource.query(this.query).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.listsLoading=false;
	        }else{
	        	var _this=this;
	            this.lists = JSON.parse(Base64.decode(res.data.Data));
	            this.lists.forEach(function(e,index) {_this.lists[index].showthumb=_this.GLOBAL.staticUrl+e.thumb;});
	            this.total_rows=parseInt(res.data.count);
	            this.listsLoading=false;

				//调整图片适配
				var _this=this;
				var imgs="";
				setTimeout(function() {
					_this.lists.forEach(function(e,index){  
							imgs=document.getElementById("imginfo"+e.id);
							var img = new Image();
							img.src = imgs.src;
							var width='0'; var height="0"; var left="0"; var top="0";
							img.onload = function(){
								img.onload =null;
								callback(img);
							}

							width=img.width; height=img.height;
							if(width/height==1) {
								width=65; height=65;
								left=42.5;top=2.5;
							}else if(width/height!=1 && width > height) { //非正方形图片宽大于高时,进行缩小处理
								var newwidth=120; var newheight=newwidth*height/width;
								width=newwidth; height=newheight;
								left=15; top=(70-newheight)/2;

							}else if(width/height!=1 && height > width) { //非正方形图片高大于宽时,进行缩小处理
								var newheight=70; var newwidth=width*newheight/height;
								width=newwidth; height=newheight;
								top=5; left=(70-newwidth)/2
							}

							e.width=width+'px';e.height=height+'px';e.left=left+"px";e.top=top+"px";
					});
					_this.lists=JSON.parse(JSON.stringify(_this.lists));
				},500);


	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
            this.listsLoading=false;
        });
    },
    
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getadlists();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getadlists();
    },
    
    /** 发布广告 **/
    add() {
    	this.$emit('listenchild',{name:'发布广告',url:'Adadd'});
    	/**
    	this.create.name='';
        this.create.pid='';
        this.create.brandid='';
        this.create.catid=[];
        this.create.date=[];
        this.create.type='1';
        this.create.pettype='';
        this.create.url='';
        this.create.thumb='';
        this.create.showthumb='';
        this.create.goods=[];
    	this.adDialog=true;
    	*/
    },
    
    /** 点击获取商品列表信息 **/
    addgoods(type) {
    	//重置搜索商品信息
    	this.goodsquery.catid=[];
        this.goodsquery.brandid='';
        this.goodsquery.key='';
        this.goodsquery.p=1;
        this.goodsquery.rollpage=10;
    
    	this.addtype=type;
    	this.goodsDialog=true;
    	this.getgoodslists();
    },
    
    /** 获取商品信息 **/
    getgoodslists() {
    	if(this.goodsisnewselect==true) {
    		this.goodsquery.p=1;
    		this.goodsquery.rollpage=10;
    	}
        
    	this.goodsbrandLoading=true;
    	this.pclickstatus=[]; //重新设置商品/品牌状态
    	this.multipleSelection=[]; //重新设置已选中的商品/品牌
        var resource = this.$resource(this.url);
        resource.save(this.goodsquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.goodsbrandLoading=false;
	        }else{
	        	var _this=this;
	            this.goodlists = JSON.parse(Base64.decode(res.data.Data));
	            this.goodslits_total_rows=parseInt(res.data.count);
	            //设置单行信息状态为未选择
	            this.goodlists.forEach(function(e,index) {_this.pclickstatus[index]=0;});
	            this.goodsbrandLoading=false;
	            if(this.goodsisnewselect==true) this.goodsisnewselect=false;
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
            this.goodsbrandLoading=false;
        });
    },
    
    goodspageSizeChange(val) {
        this.goodsquery.rollpage = val;
        this.getgoodslists();
    },
    goodspageCurrentChange(val) {
        this.goodsquery.p = val;
        this.getgoodslists();
    },
    
    /** 选中需要选择的商品信息 **/
    ensureCurrent(item) {
    	if(this.addtype=='create') {
    		this.create.goods=[];
    		this.create.goods.push({id:item.id,name:item.name});
    	}else {
    		this.update.goods=[];
    		this.update.goods.push({id:item.id,name:item.name});
    	}
    	this.goodsDialog=false;
    },
    
    /** 上传广告图片 **/
    filecreateminiChange(el,type) {
    	var resource = this.$resource(this.GLOBAL.uploadUrl);
    	var formData = new FormData();
    	formData.append('file', el.target.files[0]);
		formData.append('sys_type', 'cz');
		formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
    	resource.save(formData).then((res) => {
	    	var data=JSON.parse(Base64.decode(res.body.Data));
	        if(data.Result > 0) {
	            this.$message.error(data.msg);
	        }else {
	        	if(type=='create') {
	        		this.create.showthumb=this.GLOBAL.staticUrl+data.imgsrc;
	            	this.create.thumb=data.imgsrc;
	        	}else {
	        		this.update.showthumb=this.GLOBAL.staticUrl+data.imgsrc;
	            	this.update.thumb=data.imgsrc;
	        	}
			    el.target.value = '';  
	        }
	     }).catch((res) => {
	        	
	     });
    },
    
    /** 保存广告信息 **/
    createadSave() {
    	this.createadLoading=true;  
	    var resource = this.$resource(this.url);
        resource.save(this.create).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.createadLoading=false;
	        }else{
	        	this.$message.success("添加广告成功！");
	        	this.createadLoading=false;
	        	this.adDialog=false;
	        	this.getadlists();
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
            this.createadLoading=false;
        });    
    },
    
    /** 编辑广告信息 **/
    editCurrent(item) {
    	this.$emit('listenchild',{name:'编辑广告',url:'Adedit',data:item});
    	
    	/**
    	this.update.id=item.id;
        this.update.name='';
        this.update.pid='';
        this.update.brandid='';
        this.update.catid=[];
        this.update.date=[];
        this.update.type='1';
        this.update.pettype='';
        this.update.url='';
        this.update.thumb='';
        this.update.showthumb='';
        this.update.goods=[];
        this.updateDialog=true;
		
		var resource = this.$resource(this.url);
        resource.save({act:'getinfos',token:this.$cookies.get('token'),id:item.id}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	        	var result = JSON.parse(Base64.decode(res.data.Data));
	        	this.update.name=result.name;
		        this.update.pid=result.pid;
		        this.update.brandid=result.brandid;
		        this.update.catid=result.catid;
		        this.update.date=result.date;
		        this.update.type=result.type;
		        this.update.pettype=result.pettype;
		        this.update.url=result.url;
		        this.update.thumb=result.thumb;
		        this.update.showthumb=this.GLOBAL.staticUrl+result.thumb;
		        this.update.goods=result.goods;
	        }
        }).catch((res) => {
            
        }); 
        */       	
    },
    
    
    /** 更新广告信息 **/
    updateadSave() {
    	this.updateadLoading=true;  
	    var resource = this.$resource(this.url);
        resource.save(this.update).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.updateadLoading=false;  
	        }else{
	        	this.$message.success("更新广告成功！");
	        	this.updateadLoading=false; 
	        	this.updateDialog=false;
	        	this.getadlists();
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
            this.updateadLoading=false; 
        }); 
    },
    
    /** 删除广告信息 **/
    delCurrent(item) {
    	this.$confirm('您是否需要删除广告： ' + item.name + ', 是否继续?', '提示', { type: 'warning' }).then(() => {
        	// 向请求服务端删除
            var resource = this.$resource(this.url);
            resource.save({ act:'del',id: item.id,token:this.$cookies.get('token')}).then((res) => {
            	if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                }else{
                    this.$message.success('删除广告：' + item.name + '成功!');
                    this.getadlists();
                }
            }).catch((res) => {
            	this.$message.error(this.GLOBAL.errortext);
            });
        }).catch(() => {
        	
        });
    },
    
    //获取新国货活动的信息（新国货活动结束后删除，2019年1月2日删除该方法）
    agentinternals() {
    	var resource = this.$resource(this.GLOBAL.domain+"Goods/index");
        resource.save({act:'getinternals',token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                var infos=JSON.parse(Base64.decode(res.data.Data));
                if(infos.result==1) this.typelists.push({id:'5',name:'跳转新国货'});
            }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });  	
    },

	/** 获取可设置的广告位信息 **/
	setaplike() {		
		let _this=this;
		this.adpDialog=true;
		this.adploading=true;

		var apids=[];
		if(this.apsearchlists) this.apsearchlists.forEach(function(item,i) {apids.push(item.id);});
		this.plists.forEach(function(item,i) {
			apids.indexOf(item.id)==-1 ? item.isselect=0 : item.isselect=1;
		});
	},

	/** 修改个人搜索喜好 **/
	changelike(item,index) {
		let _this=this;
		this.apsearchlists=[];
		this.plists.forEach(function(item,i) {
			if(i==index) item.isselect==0 ? item.isselect=1 : item.isselect=0;
			if(item.isselect==1) _this.apsearchlists.push({id:item.id,name:item.name});
		});
		this.plists=JSON.parse(JSON.stringify(this.plists));
		this.$cookies.set('aplists',JSON.stringify(_this.apsearchlists));
	},

	/** 获取广告位信息列表 **/
	getpositioninfos() {
		this.adplistsDialog=true;
		this.getposition();
	},

	/** 设置广告位背景图引导 **/
	saveapthumbs(id,index) {
		this.apthumbquery.id=id;
		this.apthumbquery.thumb='';
		this.apthumbquery.index=index;
		document.getElementById('shareimg').click();
	},

	/** 提取图片信息 **/
    getaddimg(obj) {
        var file=obj.target.files[0]; //获取文件信息
    	var formData = new FormData();
    	formData.append('file', file);
		formData.append('sys_type', 'cz');
		formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
    	var resource = this.$resource(this.GLOBAL.uploadUrl);
    	resource.save(formData).then((res) => {
	    	var data=JSON.parse(Base64.decode(res.body.Data));
		    if(data.Result > 0) {
		    	this.$message.error(data.msg);
		    }else {
				this.apthumbquery.thumb=data.imgsrc;
				this.plists[this.apthumbquery.index].thumb=data.imgsrc;
            	obj.target.value = '';
				this.saveapthumbsinfos();  
	        }
	    }).catch((res) => {
	        
	    });
    },

	/** 上传更新数据 **/
	saveapthumbsinfos() {
		var resource = this.$resource(this.url);
        resource.save(this.apthumbquery).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{

            }
        }).catch((res) => {
            
        });  	
	},

	/** 修改广告位尺寸 **/
	changewah(item) {
		var resource = this.$resource(this.url);
        resource.save({act:'saveapsize',token:this.$cookies.get('token'),id:item.id,width:item.width,height:item.height}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{

            }
        }).catch((res) => {
            
        });  	
	},

   } 
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.express-warning {padding:5px;border-radius:5px;background-color:rgb(192,196,204,.4);border:1px solid rgb(192,196,204,.1);color:#f56c6c;font-size:12px;line-height:20px;margin-bottom:10px}
.ad-position-infos {float:left;width:100%}
.ad-position-infos ul {padding:0;margin:0;float:left;width:100%}
.ad-position-infos li {float:left;margin-bottom:20px;padding:0 0 20px 0;list-style:none;background:rgb(221,221,221,.3);border-radius:5px;border:1px solid #dddddd;border-radius:5px}
.ad-position-infos li:hover {transition:all .3s;box-shadow: 8px 8px 10px rgb(211,211,211);}
.ad-position-infos li:nth-child(odd) {width:48%;margin-right:3%}
.ad-position-infos li:nth-child(even) {width:48%;}
.ad-position-infos li a {float:left;width:100%;border-radius:5px;height:350px;margin-top:0;overflow:hidden;cursor:pointer}
.ad-position-infos li a img {float:left;width:100%}
.ad-position-infos li .name {float:left;margin-top:20px;margin-left:4%}
.ad-position-infos li .size {float:left;margin-top:10px;margin-left:4%;width:92%}
.ad-position-infos li .size i {float:left;margin:0 2%;font-style:normal}

.showadimg {border-radius:5px;float:left}
</style>


// WEBPACK FOOTER //
// src/components/mall/Ad.vue